import { useEffect, useState } from "react"
import { useUserModalContext } from "../../../Contexts/UserModalContext/UserModalProvider"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import GroupHomeNotices from "../../../Components/SharedComponents/GroupData/GroupHomeNotices"
import GroupHomeNewsLetters from "../../../Components/SharedComponents/GroupData/GroupHomeNewsLetters"
import '../UserModalCSS.css'


function UserHomeModal() {

	const [currentlyShowing, setCurrentlyShowing] = useState<'Notice' | 'NewsLetters'>('Notice')
	const { isFirstUpdate, updateNotices, isLoadingInfo } = useUserModalContext()
	const { setCurrentModal } = useGeneralContext()

	// The first load is started by the page, so Entrada only refreshes on later visits.
	useEffect(() => {
		if (!isFirstUpdate) {
			updateNotices()
		}
		// Only on arriving at Entrada, not every time the notices change.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleCreateButton = () => {
		if (currentlyShowing === 'Notice') {
			setCurrentModal('CreateNotice')
		} else {
			setCurrentModal('CreateNewsLetter')
		}
	}

	return (
		<>
			<div className="HomeModalSuperiorDiv BottomLine">
				<div className="HomeModalButtonDiv">
					<button
						type='button'
						className={currentlyShowing === 'Notice' ? 'HomeModalSelectedType' : 'HomeModalUnselectedType'}
						onClick={() => setCurrentlyShowing('Notice')}
					>
						Avisos
					</button>
					<button
						type='button'
						className={currentlyShowing === 'NewsLetters' ? 'HomeModalSelectedType' : 'HomeModalUnselectedType'}
						onClick={() => setCurrentlyShowing('NewsLetters')}
					>
						Boletin
					</button>
				</div>
				<div className="HomeModalSuperiorInteriorDiv">
					<button
						type='button'
						onClick={handleCreateButton}
					>
						{currentlyShowing === 'Notice' ? 'Nuevo Aviso' : 'Nueva nota'}
					</button>
				</div>
			</div>
			{isLoadingInfo ? (
				<h1>Cargando...</h1>
			) : (
				currentlyShowing === 'Notice' ? (
					<GroupHomeNotices />
				) : (
					<GroupHomeNewsLetters />
				)
			)}
			
		</>
	)
}

export default UserHomeModal